/*
* 本地存取
* 用途：数据在本地的存取
* 用法：vue.$storage
* 方法：
*     set
*     get
* */
import typejudge from './typejudge.js';
import conversion from './conversion.js';
class storage {
  set (key, message) { // 存储数据到本地  key:字段名称  message:存储的值
    key = typeof key === 'string' ? key : String(key);
    var stringnumber = '';
    if (typejudge.isArray(message)) { // 如果是数组，则数组转换成字符串
      stringnumber = conversion.ArrayToString(message);
    } else if (typejudge.isJson(message)) { // 如果是json，则json转换成字符串
      stringnumber = JSON.stringify(message);
    } else {
      stringnumber = message;
    }
    localStorage.setItem(key, stringnumber);
  };

  get (key) { // 从本地取数据
    key = typeof key === 'string' ? key : String(key);
    var getMessage = localStorage.getItem(key) || '';
    var real = null;
    /*
    * 这里要注意，由于使用程序自动判断字符串原本类型，
    * json字符串也会被判定为数组，所有需要先判断是不是json
    * 再判断是不是数组，顺序不可改变
    * */
    if (getMessage && typejudge.isJson(JSON.parse(getMessage))) {
      real = JSON.parse(getMessage);
    } else if (getMessage && conversion.StringToArray(getMessage)) {
      real = conversion.StringToArray(getMessage);
    } else {
      real = getMessage;
    }
    return real;
  }
}
// export storage类的对象
export default new storage();



// WEBPACK FOOTER //
// ./src/utils/storage.js